import styled from 'styled-components';

export const SettingsBox = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

export const SettingsBoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  h6 {
    font-size: 16px;
    margin: 0;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    margin: 6px 0 0 0;
    color: ${props => props.theme.colors.gray6};
  }
`;

export const SettingsBoxContent = styled.div`
  & > div {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
    & > p {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    & > label {
      margin-bottom: 16px;
      font-size: 14px;
    }
    textarea {
      font-size: 14px;
    }
  }
`;
